import { EMOJI, spokenText } from '../phrases';

export { spokenText };

export const ORDER_SEPARATOR = '';

export function termOf(text: string): string {
  return spokenText(text).toLowerCase();
}

export function shuffle<T>(arr: readonly T[]): T[] {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export function pick<T>(arr: readonly T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}

export function splitFace(text: string): { picture: string; word: string } {
  const pics = text.match(EMOJI) ?? [];
  return { picture: pics.join(''), word: spokenText(text) };
}
